import useApiWorker from 'hooks/useApiWorker';
import { StudentData } from 'types/snackpack-student-data';

export async function GetSnackpackStudentData(stateStudentId: string): Promise<ApiResponse<StudentData>> {
  const apiWorker = useApiWorker();
  return apiWorker
    .get<StudentData>(`/snackpack/student/${stateStudentId}`)
    .then((result) => {
      return { success: true, data: result.data };
    })
    .catch((error) => {
      if (error.response.status === 404) {
        return {
          success: false,
          message: `No student found with given State Student Id: ${stateStudentId}`,
        };
      }
      return {
        success: false,
        message: error.response.data.message,
      };
    });
}
